/**
 * A score or a weight: two decimals always — a weight is stored to two — as the applicant's Summary
 * prints them. Rendered in the mono face, as every figure.
 */
export function formatPoints(value: number): string {
  return value.toFixed(2);
}
